import { render, staticRenderFns } from "./StatisticTableViewOfferOutput.vue?vue&type=template&id=7707b4cc&scoped=true"
import script from "./StatisticTableViewOfferOutput.vue?vue&type=script&lang=js"
export * from "./StatisticTableViewOfferOutput.vue?vue&type=script&lang=js"
import style0 from "./StatisticTableViewOfferOutput.vue?vue&type=style&index=0&id=7707b4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7707b4cc",
  null
  
)

export default component.exports